import { Pipe, PipeTransform } from '@angular/core';
import { UtilCommon } from '../common/utils/UtilCommon';

@Pipe({
    name: 'formatBreadcrumbNumber',
    standalone: true
})
export class FormatBreadcrumbNumber implements PipeTransform {
    transform(value: any): string {
        const num = parseInt((value + '').replace(/[()]/g, ''), 10);
        const numFormat = UtilCommon.formatNumber(num);
        if (numFormat) {
            return '(' + UtilCommon.formatNumber(num) + ')';
        }
        return ''
    }
}
